export default __webpack_public_path__ + "static/media/embarazo.343a4d83.svg";